(function() {
  const waitForProductMedia = setInterval(() => {
    const originalProductMedia = customElements.get('product-media');
    if (!originalProductMedia) return;
    
    clearInterval(waitForProductMedia);
    
    let currentGalleryKey = null;
    
    async function filterGallery(productMedia, variantId, isInitialLoad = false) {
      const variantGalleriesAttr = productMedia.getAttribute('data-variant-galleries');
      const mediaFilenamesAttr = productMedia.getAttribute('data-media-filenames');
      
      if (!variantGalleriesAttr || !mediaFilenamesAttr) {
        console.warn('Gallery data attributes missing');
        return;
      }
      
      try {
        const variantGalleries = JSON.parse(variantGalleriesAttr);
        const mediaFilenames = JSON.parse(mediaFilenamesAttr);
        const galleryFilenames = variantGalleries[variantId.toString()] || [];
        
        const newGalleryKey = galleryFilenames.join(',');
        if (!isInitialLoad && newGalleryKey === currentGalleryKey) {
          return;
        }
        currentGalleryKey = newGalleryKey;
        
        const list = productMedia.querySelector('.product__media-list');
        
        // Ausblenden vor dem Wechsel (nicht beim ersten Laden)
        if (!isInitialLoad && list) {
          list.classList.add('is-transitioning');
          await new Promise(resolve => setTimeout(resolve, 250));
        }
        
        let visibleCount = 0;
        
        if (galleryFilenames.length === 0) {
          // Keine Gallery definiert - alle anzeigen
          productMedia.querySelectorAll('[data-media-id]').forEach(item => {
            item.style.display = '';
            item.classList.remove('is-filtered');
          });
          visibleCount = productMedia.querySelectorAll('.product__media-item').length;
        } else {
          // Gallery filtern
          const filteredMediaIds = [];
          for (const [mediaId, filename] of Object.entries(mediaFilenames)) {
            if (!galleryFilenames.includes(filename)) {
              filteredMediaIds.push(parseInt(mediaId));
            }
          }
          
          // Main carousel items
          productMedia.querySelectorAll('.product__media-item[data-media-id]').forEach(item => {
            const mediaId = parseInt(item.getAttribute('data-media-id'));
            const shouldHide = filteredMediaIds.includes(mediaId);
            item.style.display = shouldHide ? 'none' : '';
            item.classList.toggle('is-filtered', shouldHide);
            if (!shouldHide) visibleCount++;
          });
          
          // Thumbnails
          productMedia.querySelectorAll('.product__thumbnail-item[data-media-id]').forEach(item => {
            const mediaId = parseInt(item.getAttribute('data-media-id'));
            const shouldHide = filteredMediaIds.includes(mediaId);
            item.style.display = shouldHide ? 'none' : '';
            item.classList.toggle('is-filtered', shouldHide);
          });
          
          // Dots
          productMedia.querySelectorAll('.dots-nav__item[data-media-id]').forEach(item => {
            const mediaId = parseInt(item.getAttribute('data-media-id'));
            const shouldHide = filteredMediaIds.includes(mediaId);
            item.style.display = shouldHide ? 'none' : '';
            item.classList.toggle('is-filtered', shouldHide);
          });
        }
        
        console.log(`Gallery filtered: ${visibleCount} visible images`);
        
        // Flickity aktualisieren
        if (productMedia.mainCarousel) {
          const flickity = await productMedia.mainCarousel.flickityInstance;
          if (flickity) {
            // WICHTIG: Bei nur 1 Bild Flickity komplett neu initialisieren
            if (visibleCount === 1) {
              // Flickity deaktivieren für Single Image
              flickity.options.draggable = false;
              flickity.options.pageDots = false;
              flickity.options.prevNextButtons = false;
              flickity.options.wrapAround = false;
            } else {
              // Flickity aktivieren für Multiple Images
              flickity.options.draggable = true;
              flickity.options.pageDots = true;
              flickity.options.prevNextButtons = true;
              flickity.options.wrapAround = true;
            }
            
            flickity.reloadCells();
            flickity.resize();
            flickity.select(0, false, true);
            
            if (flickity.pageDots) {
              flickity.pageDots.setDots();
            }
            
            // Force layout recalculation
            void productMedia.mainCarousel.offsetHeight;
          }
        }
        
        // Einblenden nach dem Wechsel
        if (list) {
          await new Promise(resolve => setTimeout(resolve, 50));
          list.classList.remove('is-transitioning');
          list.classList.add('is-ready');
        }
        
      } catch (e) {
        console.error('Gallery filter error:', e);
      }
    }
    
    originalProductMedia.prototype._onVariantChanged = async function(event) {
      const variant = event.detail.variant;
      await filterGallery(this, variant.id);
      this.selectedVariantMediaId = variant.featured_media?.id || null;
    };
    
    // Initial load für alle product-media Elemente
    document.querySelectorAll('product-media').forEach(async (productMedia) => {
      const urlParams = new URLSearchParams(window.location.search);
      let variantId = urlParams.get('variant');
      
      if (!variantId) {
        const formId = productMedia.getAttribute('form-id');
        const form = document.getElementById(formId);
        const input = form?.querySelector('input[name="id"]');
        variantId = input?.value;
      }
      
      if (variantId) {
        let attempts = 0;
        const maxAttempts = 60; // 3 Sekunden
        
        const checkFlickity = setInterval(async () => {
  attempts++;
  
  // SOFORT filtern wenn mainCarousel existiert, nicht auf flickityInstance warten
  if (productMedia.mainCarousel) {
    clearInterval(checkFlickity);
    console.log('MainCarousel found, filtering gallery...');
    
    // Filter sofort ausführen
    await filterGallery(productMedia, variantId, true);
  }
          
          if (attempts >= maxAttempts) {
            clearInterval(checkFlickity);
            console.warn('Flickity timeout, showing all images');
            const list = productMedia.querySelector('.product__media-list');
            if (list) list.classList.add('is-ready');
          }
        }, 50);
      } else {
        // Keine Variante ausgewählt - alles anzeigen
        const list = productMedia.querySelector('.product__media-list');
        if (list) list.classList.add('is-ready');
      }
    });
    
    console.log('Metafield Gallery Script loaded!');
  }, 100);
})();